export const LOCALES = {
  ENGLISH_US: 'en-US',
  ENGLISH_UK: 'en-GB',
  FINNISH: 'fi-FI',
} as const;
